import type { SubscriptionOnboardingVariant } from './container/onboardingSession';
import type { EnterpriseInvitationUser } from '@m/types/api/EnterpriseInvitation';

export type OnboardingExperimentCohort = 'agnostic' | 'enterprise' | 'individual' | 'stp';
export type SignInOnboardingExperimentCohort = Exclude<OnboardingExperimentCohort, 'stp'>;

type OnboardingExperimentCohortContext = {
  enterpriseUser: EnterpriseInvitationUser | undefined;
  individualSubscriptionInvitationId: string | null | undefined;
  pendingSubscriptionVariant?: SubscriptionOnboardingVariant | null;
  search: string;
};

type StpOnboardingTasks = {
  confirmVisit?: unknown;
  selectVisitDuration?: unknown;
};

export function hasEnterpriseInvitationParams(search: string): boolean {
  const searchParams = new URLSearchParams(search);
  return (
    !!searchParams.get('ent_token') ||
    (!!searchParams.get('token') && !!searchParams.get('employeeId'))
  );
}

export function resolveOnboardingExperimentCohort({
  enterpriseUser,
  individualSubscriptionInvitationId,
  pendingSubscriptionVariant,
  search,
}: OnboardingExperimentCohortContext): SignInOnboardingExperimentCohort {
  const searchParams = new URLSearchParams(search);
  const hasEnterpriseInvitation = !!enterpriseUser || hasEnterpriseInvitationParams(search);

  if (hasEnterpriseInvitation) return 'enterprise';
  if (individualSubscriptionInvitationId || searchParams.get('subInviteId')) return 'individual';
  if (pendingSubscriptionVariant === 'enterpriseSub') return 'enterprise';
  if (pendingSubscriptionVariant === 'individualSub') return 'individual';
  return 'agnostic';
}

export function hasStpOnboardingTasks(
  onboardingTasks: StpOnboardingTasks | null | undefined,
): boolean {
  return !!(onboardingTasks?.selectVisitDuration || onboardingTasks?.confirmVisit);
}
